module.exports = __webpack_public_path__ + "img/course_bg01.502b371e.png";